// src/main.tsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { PWAProvider } from './features/pwa/PWAProvider'
import { ToastProvider } from './shared/providers/ToastProvider';
import { createPersistentQueryClient } from './features/pwa/offline-query'
import { QueryClientProvider } from '@tanstack/react-query'
import './main.css'
import './index.css'

const queryClient = createPersistentQueryClient()
const rootElement = document.getElementById('root')

if (!rootElement) throw new Error('Root element not found')

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <PWAProvider>
          <App />
        </PWAProvider>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>
)